// @flow

import { isEqual } from "lodash";
import * as React from "react";
import queryString from "query-string";
import { withRouter, useHistory } from "react-router-dom";

import scrollToEl from "../../utils/scrollToEl";
import Pagination from "../molecules/Pagination";
import Icon from "../atoms/Icon";
import { ReactComponent as Circle } from "../../../assets/images/shape-circle.svg";

type PropsType = {
    id: any,
    attendees: any,
    onAttendeeClick: any,
};

const ManageEventAttendees = (props: PropsType): React.Node => {
    const history = useHistory();
    const POSTS_PER_PAGE = 24;
    const PAGINATION_WIDTH = 2;
    const [params, setParams] = React.useState({ page_num: 1 });
    const [query, setQuery] = React.useState("");
    const [results, setResults] = React.useState([]);
    const [error, setError] = React.useState(null);

    const queryParamProps = queryString.parse(history.location.search);
    const activePage = Number(queryParamProps.page_num) || 1;
    const totalPages = Math.ceil(results.length / POSTS_PER_PAGE);

    if (!isEqual(queryParamProps, params)) {
        setParams(queryParamProps);

        // scroll to searchbar
        const el = document.querySelector("#manage-event-nav");
        if (el) {
            scrollToEl(el);
        }
    }

    React.useEffect(() => {
        const searchValue = query.toLowerCase();
        const results = [];

        props.attendees.forEach(attendee => {
            if (
                (attendee.first_name &&
                    attendee.first_name.toLowerCase().includes(searchValue)) ||
                (attendee.last_name &&
                    attendee.last_name.toLowerCase().includes(searchValue)) ||
                (attendee.last_name &&
                    attendee.first_name &&
                    `${attendee.first_name.toLowerCase()} ${attendee.last_name.toLowerCase()}`.includes(
                        searchValue
                    )) ||
                (attendee.email &&
                    attendee.email.toLowerCase().includes(searchValue))
            ) {
                results.push(attendee);
            }
        });

        if (!query) {
            setResults(props.attendees);
            if (props.attendees.length === 0) {
                setError("No tickets have been issued for this event. ");
            }
        } else {
            setResults(results);
            if (results.length === 0) {
                setError(
                    "No results found. Make sure the name or email is spelt correctly, or try using less characters."
                );
            }
        }
    }, [query, props.attendees]); // eslint-disable-line

    const handleQueryChange = e => {
        // reset pagination query
        history.replace({
            pathname: document.location.pathname,
            search: "",
        });
        // set query value
        setQuery(e.currentTarget.value);
    };

    return (
        <div className="manage-event-attendees">
            <div className="manage-event-attendees__search">
                <div className="manage-event-attendees__search__icon">
                    <Icon name="search" />
                </div>
                <input
                    onChange={handleQueryChange}
                    type="search"
                    name="search"
                    aria-label="Search"
                    placeholder="Search names & emails"
                />
            </div>

            {results.length > 0 ? (
                results
                    .slice(
                        (activePage - 1) * POSTS_PER_PAGE,
                        POSTS_PER_PAGE * activePage
                    )
                    .map((attendee, key) => {
                        const name = `${attendee.first_name} ${attendee.last_name}`;
                        const classList = ["manage-event-attendees__attendee"];

                        if (attendee.is_checkin) {
                            classList.push("checked-in");
                        }

                        return (
                            <div
                                key={key}
                                className={`${classList.join(" ")}`}
                                onClick={() => props.onAttendeeClick(attendee)}
                            >
                                <div className="manage-event-attendees__attendee__left-content">
                                    <div className="manage-event-attendees__attendee__left-content__inner">
                                        {attendee.is_checkin ? (
                                            <div className="manage-event-attendees__attendee__checked-in">
                                                <Icon name="tick" />
                                            </div>
                                        ) : (
                                            <Circle className="manage-event-attendees__attendee__circle" />
                                        )}
                                        <div className="manage-event-attendees__attendee__name">
                                            {name}
                                        </div>
                                    </div>
                                    <div className="manage-event-attendees__attendee__email">
                                        {attendee.email}
                                    </div>
                                </div>
                                <div className="manage-event-attendees__attendee__arrow">
                                    <Icon name="chevron-right" />
                                </div>
                            </div>
                        );
                    })
            ) : (
                <div>{error}</div>
            )}

            {/* Listing pagination */}
            {totalPages > 1 ? (
                <div className="row">
                    <div className="col-xs-12">
                        <Pagination
                            ellipsisWidth={PAGINATION_WIDTH}
                            pages={totalPages}
                            activePage={activePage}
                        />
                    </div>
                </div>
            ) : null}
        </div>
    );
};

ManageEventAttendees.preload = ({
    location,
    passed: { store },
}: any): Promise<any> => {
    return Promise.all([]);
};

export default withRouter(ManageEventAttendees);
